const keyPrefix = 'citrus'

export const getBase64Key = (keyName: string): string => {
  return btoa(unescape(encodeURIComponent(`${keyPrefix}-${keyName}`)))
}

export const getBase64Value = (keyValue: any): string => {
  let value = ''
  try {
    if (keyValue && typeof keyValue !== 'string') {
      value = JSON.stringify(keyValue)
    } else if (typeof keyValue === 'string') {
      value = keyValue
    }
  } catch {
    value = keyValue || ''
  }
  return btoa(unescape(encodeURIComponent(value)))
}

export const getObjectValue = (base64Value?: string): any => {
  if (!base64Value) return null
  const b = base64Value ? decodeURIComponent(escape(atob(base64Value))) : null
  let value = {}
  try {
    if (b) {
      value = JSON.parse(b)
    }
  } catch {
    value = b || ''
  }
  return value
}

export const getLocalStorageItem = (keyName: string, version: string = '2021-11-08'): any => {
  const name = getBase64Key(keyName)
  const value = window.localStorage.getItem(name) || undefined
  const obj = getObjectValue(value)
  return obj?.version === version ? obj.value : null
}

export const setLocalStorageItem = (
  keyName: string,
  keyValue?: any,
  version: string = '2021-11-08',
): void => {
  const name = getBase64Key(keyName)
  const value = getBase64Value({ value: keyValue, version })
  window.localStorage.setItem(name, value)
}

export const removeLocalStorageItem = (keyName: string): void => {
  const name = getBase64Key(keyName)
  window.localStorage.removeItem(name)
}
